import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { AuthSelectors } from '@states/auth/auth.selectors';

/**
 * Auth guard - protects routes that require authentication
 * - Redirects unauthenticated users to sign-in with returnUrl
 * - Allows any authenticated user
 *
 * Used as a parent-route guard to group auth-required routes.
 */
export const authGuard: CanActivateFn = (_route, state) => {
  const store = inject(Store);
  const router = inject(Router);

  const user = store.selectSnapshot(AuthSelectors.getUser);

  if (!user) {
    return router.createUrlTree(['/sign-in'], {
      queryParams: { returnUrl: state.url },
    });
  }

  return true;
};
